import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/Admin.scss";
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import MyCommandCell from './myCommandCell.jsx';
import { CircularProgress } from "@material-ui/core";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import { Popup } from "@progress/kendo-react-popup";

class RiskStage extends Component {
    editField = "inEdit";
    currentComponent = 'riskType'
    state = {
        data: [],
        loader: false,
        skip:0,
        take:10,
        delete: false,
    };
    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take,
        });
    };

    componentDidMount() {
        this.getRiskType();
    }
    getRiskType = async () => {
        try {
            this.setState({ ...this.state, loader: true });
            let response = await Api.getAdminRiskType();
            if (response.status === 200 && response.riskTypes) {
                this.setState({ ...this.state, loader: false });
                this.setState({ data: response.riskTypes });
            } else {
                this.setState({ ...this.state, loader: false });
                this.setState({ data: [] });
            }
        } catch (error) {
            this.setState({ ...this.state, loader: false });
            console.error(error);
        }
    }

    CommandCell = props => (
        <MyCommandCell
            { ...props }
            edit={ this.enterEdit }
            handledelete={this.handledelete}
            add={ this.add }
            discard={ this.discard }
            update={ this.update }
            cancel={ this.cancel }
            editField={ this.editField }
            currentComponent={ this.currentComponent }
        />
    );

    discard = dataItem => {
        const data = [...this.state.data];
        data.splice(0, 1)
        this.setState({ data });
    };
    handledelete= (dataItem)=>{
        this.setState({
          delete:!this.state.delete,
          riskTypeId: dataItem.riskTypeId,
        })
        
       
      }
      handleclose=()=>{
        this.setState({
          delete:!this.state.delete,
          riskTypeId:0
        })
       
      }
    // modify the data in the store, db etc
    remove = async() => {
        try {
            let loggedClient = secureLocalStorage.getItem("loggedClient");
            let createdby =
                loggedClient == "user"
                    ? secureLocalStorage.getItem("userId")
                    : secureLocalStorage.getItem("tenantId");
            let requestParams = {
                "RiskTypeId": this.state.riskTypeId,
                "DeletedBy": parseInt(createdby)
            }
            this.setState({ ...this.state, loader: true });
            let response = await Api.deleteRiskType(requestParams);
            if (response.status === 200) {
                this.setState({ ...this.state, loader: false });
                toastr.success(response.message);
                this.getRiskType();
                this.setState({
                    delete:false,
                  })
            } else {
                toastr.error(response.message);
                this.setState({ ...this.state, loader: false });
            }
        } catch (error) {
            this.setState({ ...this.state, loader: false });
            console.error(error);
        }
    };

    add = async dataItem => {
        if (!dataItem.name||dataItem.name.trim()=="") {
            toastr.error('Type is required');
            return
        } else {
            try {
                let requestParams = {
                    "Name": dataItem.name.trim()
                }
                this.setState({ ...this.state, loader: true });
                let response = await Api.addRiskType(requestParams);
                if (response.status === 200) {
                    this.setState({ ...this.state, loader: false });
                    toastr.success(response.message);
                    this.getRiskType();
                } else {
                    toastr.error(response.message);
                    this.setState({ ...this.state, loader: false });
                }
            } catch (error) {
                this.setState({ ...this.state, loader: false });
                console.error(error);
            }
        }

    };

    update = async dataItem => {
        if (!dataItem.name||dataItem.name.trim()=="") {
            toastr.error('Type is required');
            return
        } else {
            try {
                dataItem.inEdit = false;
                let loggedClient = secureLocalStorage.getItem("loggedClient");
                let createdby =
                    loggedClient == "user"
                        ? secureLocalStorage.getItem("userId")
                        : secureLocalStorage.getItem("tenantId");
                let requestParams = {
                    "Name": dataItem.name.trim(),
                    "RiskTypeId": dataItem.riskTypeId,
                    "UpdatedBy": parseInt(createdby)
                }
                this.setState({ ...this.state, loader: true });
                let response = await Api.updateRiskType(requestParams);
                if (response.status === 200) {
                    this.setState({ ...this.state, loader: false });
                    toastr.success(response.message);
                    this.getRiskType();
                } else {
                    toastr.error(response.message);
                    this.setState({ ...this.state, loader: false });
                }
            } catch (error) {
                this.setState({ ...this.state, loader: false });
                console.error(error);
            }
        }
    };

    cancel = dataItem => {
        this.getRiskType();
    };

    enterEdit = dataItem => {
        const dataValue = this.state.data.map((item) => ({
            ...item,
            inEdit:
                item.riskTypeId === dataItem.riskTypeId ? true : false,
        }))
        this.setState({
            data: dataValue
        });
    };

    itemChange = event => {
        const data = this.state.data.map(item =>
            item.riskTypeId === event.dataItem.riskTypeId
                ? { ...item, [event.field]: event.value }
                : item
        );

        this.setState({ data });
    };

    addNew = () => {
        const newDataItem = { inEdit: true, Discontinued: false };

        this.setState({
            data: [newDataItem, ...this.state.data],
            skip: 0,
            take: 10,
        });
    };

    render() {
        return (
            <div className="riskTypeCont">
                {this.state.loader ? (
                    <span className="MatTableSpinner">
                        <CircularProgress style={ { color: "#FFFFFF" } } size={ 70 } />
                    </span>
                ) : null }
                {this.state.delete ===true ?(
                <Popup
                show={this.state.delete}
                popupClass={"popup-content"} >
                  <div className="deleteModelCont">
            <h3>Are you sure you want to delete this Risk Type?</h3>
            <div className="btnCont">
              <button 
              onClick={this.remove} 
              className="deleteBtn">
                Delete
              </button>
              <button
               onClick={this.handleclose} 
               className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
          </Popup>):null
                }
                <div className="dbCard card100 noPadd">
                    <div className="gridBox">
                        <div className="tblCont dataGrids noPaddTop">
                            <div className="rw-tab-content">
                                <Grid
                                    data={ this.state.data.slice(
                                        this.state.skip,
                                        this.state.take + this.state.skip
                                    ) }
                                    onItemChange={ this.itemChange }
                                    editField={ this.editField }
                                    pageable={true}
                                    skip={this.state.skip}
                                    take={this.state.take}
                                    total={this.state.data.length}
                                    onPageChange={this.pageChange}
                                >
                                    <GridToolbar className="customHeader">

                                        <div className="gridHeader">
                                            <div className="d-flex align-items-center">
                                                <h4>Risk Type</h4>
                                                <div className="ml-auto d-flex">
                                                    <div className="btnGreen noMargin">
                                                        <button onClick={ this.addNew }>Add Type</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </GridToolbar>
                                    <Column field="name" title="Type" />

                                    <Column cell={ this.CommandCell } width="100px" title="Actions"/>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default RiskStage
